import { render, staticRenderFns } from "./OnboardingStepListTemplate.vue?vue&type=template&id=14b1d2d2"
import script from "./OnboardingStepListTemplate.vue?vue&type=script&lang=js"
export * from "./OnboardingStepListTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports